import { render, staticRenderFns } from "./optimumDrop.vue?vue&type=template&id=1d8b5027&scoped=true&"
import script from "./optimumDrop.vue?vue&type=script&lang=js&"
export * from "./optimumDrop.vue?vue&type=script&lang=js&"
import style0 from "./optimumDrop.vue?vue&type=style&index=0&id=1d8b5027&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b5027",
  null
  
)

export default component.exports